var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconResetPasswordButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#F9B218"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7188 13.625H20.25V11.75C20.25 9.68187 18.5681 8 16.5 8C14.4319 8 12.75 9.68187 12.75 11.75V13.625H12.2812C11.5063 13.625 10.875 14.2556 10.875 15.0312V21.5938C10.875 22.3694 11.5063 23 12.2812 23H20.7188C21.4937 23 22.125 22.3694 22.125 21.5938V15.0312C22.125 14.2556 21.4937 13.625 20.7188 13.625ZM14 11.75C14 10.3712 15.1213 9.25 16.5 9.25C17.8787 9.25 19 10.3712 19 11.75V13.625H14V11.75ZM17.125 18.4513V19.875C17.125 20.22 16.8456 20.5 16.5 20.5C16.1544 20.5 15.875 20.22 15.875 19.875V18.4513C15.5031 18.2344 15.25 17.8356 15.25 17.375C15.25 16.6856 15.8106 16.125 16.5 16.125C17.1894 16.125 17.75 16.6856 17.75 17.375C17.75 17.8356 17.4969 18.2344 17.125 18.4513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResetPasswordButton);
export default __webpack_public_path__ + "static/media/icon-reset-password-button.bcd4f8cb19019eb478cd15cd18e2c30f.svg";
export { ForwardRef as ReactComponent };